import { STATUS, TAKEN } from '@siza-staff-care/shared/data';

/**
 * Translates a request's status and taken status to an English string.
 * @param  {string} reqStatus
 * @param  {string} takenStatus
 */
export const translateStaffRequestStatus = (reqStatus: string, takenStatus = '') => {
	takenStatus = takenStatus || '';
	reqStatus = reqStatus || '';

	if (takenStatus && takenStatus !== TAKEN.UNKNOWN) {
		return translateTakenStatus(takenStatus);
	}

	switch (reqStatus) {
		case STATUS.PENDING:
			return 'Pending';
		case STATUS.APPROVED:
			return 'Approved';
		case STATUS.OVERRIDDEN:
			return 'Overridden';
		case STATUS.REFUSED:
			return 'Refused';
		default:
			return '';
	}
};

/**
 * Translates a request's taken status to an English string.
 * @param takenStatus
 * @returns
 */
export const translateTakenStatus = (takenStatus: string) => {
	switch (takenStatus) {
		case '':
		case TAKEN.UNKNOWN:
			return 'Not confirmed';
		case TAKEN.TAKEN:
			return 'Taken';
		case TAKEN.NOT_TAKEN:
			return 'Not taken';
		default:
			return '';
	}
};

export const translateTakenStatusToClass = (takenStatus: string) => {
	switch (takenStatus) {
		case '':
		case TAKEN.UNKNOWN:
			return 'taken-unknown';
		case TAKEN.TAKEN:
			return 'status-taken';
		case TAKEN.NOT_TAKEN:
			return 'status-not-taken';
		default:
			return '';
	}
};

export const translateStaffRequestStatusToClass = (reqStatus: string, takenStatus = '') => {
	takenStatus = takenStatus || '';
	reqStatus = reqStatus || '';

	if (takenStatus && takenStatus !== TAKEN.UNKNOWN) {
		return translateTakenStatusToClass(takenStatus);
	}

	switch (reqStatus) {
		case STATUS.PENDING:
			return 'status-pending-leave';
		case STATUS.APPROVED:
			return 'status-approved-leave';
		case STATUS.OVERRIDDEN:
			return 'status-overridden';
		case STATUS.REFUSED:
			return 'status-refused';
		default:
			return '';
	}
};

export const getStatusDisplayForRequest = (
	reqStatus: string,
	takenStatus: string,
	forShiftRequest: boolean,
	asBank: boolean,
) => {
	takenStatus = takenStatus || '';
	reqStatus = reqStatus || '';

	const status = translateStaffRequestStatus(reqStatus, takenStatus);
	const cssClass = getCssClassForRequest(reqStatus, takenStatus, forShiftRequest, asBank);

	const result = {
		status: status,
		cssClass: cssClass,
	};

	return result;
};

export const getCssClassForRequest = (
	reqStatus: string,
	takenStatus: string,
	forShiftRequest: boolean,
	asBank: boolean,
) => {
	let cssClass = '';

	switch (takenStatus) {
		case '':
		case TAKEN.UNKNOWN:
			switch (reqStatus) {
				case STATUS.PENDING:
					if (forShiftRequest) {
						cssClass = 'status-pending-shift';
					} else {
						cssClass = 'status-pending-leave';
					}

					if (asBank) {
						cssClass += '-bank';
					}
					break;

				case STATUS.APPROVED:
					if (forShiftRequest) {
						cssClass = 'status-approved-shift';
					} else {
						cssClass = 'status-approved-leave';
					}
					break;

				case STATUS.OVERRIDDEN:
					cssClass = 'status-overridden';
					break;

				case STATUS.REFUSED:
					cssClass = 'status-refused';
					break;
			}
			break;
		case TAKEN.TAKEN:
			cssClass = 'status-taken';
			break;

		case TAKEN.NOT_TAKEN:
			cssClass = 'status-not-taken';
			break;
	}

	return cssClass;
};

/**
 * Returns true if a leave status is overridden or not taken.
 * @param  {String} status
 * @param  {String} takenStatus
 */
export const isLeaveOverriddenOrNotTaken = (status, takenStatus) => {
	return status === STATUS.OVERRIDDEN || takenStatus === TAKEN.NOT_TAKEN;
};
